/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Dataflow_AtsInputs */

const en_landing_dataflow_ats = /** @type {(inputs: Landing_Dataflow_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS Systems`)
};

const de_landing_dataflow_ats = /** @type {(inputs: Landing_Dataflow_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-Systeme`)
};

const fr_landing_dataflow_ats = /** @type {(inputs: Landing_Dataflow_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS Systems`)
};

const es_landing_dataflow_ats = /** @type {(inputs: Landing_Dataflow_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS Systems`)
};

const it_landing_dataflow_ats = /** @type {(inputs: Landing_Dataflow_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS Systems`)
};

const nl_landing_dataflow_ats = /** @type {(inputs: Landing_Dataflow_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS Systems`)
};

const pl_landing_dataflow_ats = /** @type {(inputs: Landing_Dataflow_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS Systems`)
};

const fi_landing_dataflow_ats = /** @type {(inputs: Landing_Dataflow_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS Systems`)
};

const da_landing_dataflow_ats = /** @type {(inputs: Landing_Dataflow_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS Systems`)
};

const sv_landing_dataflow_ats = /** @type {(inputs: Landing_Dataflow_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS Systems`)
};

/**
* | output |
* | --- |
* | "ATS Systems" |
*
* @param {Landing_Dataflow_AtsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_dataflow_ats = /** @type {((inputs?: Landing_Dataflow_AtsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Dataflow_AtsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_dataflow_ats(inputs)
	if (locale === "fr") return fr_landing_dataflow_ats(inputs)
	if (locale === "es") return es_landing_dataflow_ats(inputs)
	if (locale === "it") return it_landing_dataflow_ats(inputs)
	if (locale === "nl") return nl_landing_dataflow_ats(inputs)
	if (locale === "pl") return pl_landing_dataflow_ats(inputs)
	if (locale === "fi") return fi_landing_dataflow_ats(inputs)
	if (locale === "da") return da_landing_dataflow_ats(inputs)
	if (locale === "sv") return sv_landing_dataflow_ats(inputs)
	return en_landing_dataflow_ats(inputs)
});